import { Link } from 'react-router-dom';
import { useCountUp } from '../../hooks/useCountUp';

export const KpiCard = ({
  title, value, suffix = '', decimals = 0, subtitle, Icon,
  iconClass = 'bg-primary/10 text-primary', to, testid, delay = 0,
}) => {
  const animated = useCountUp(value);
  const display = decimals
    ? animated.toFixed(decimals)
    : Math.round(animated).toLocaleString('es-AR');

  const Wrapper = to ? Link : 'div';
  return (
    <Wrapper
      {...(to ? { to } : {})}
      data-testid={testid}
      className={`group relative overflow-hidden bg-card border border-border/60 rounded-xl p-5 shadow-sm transition-all duration-300 dash-fade-up ${to ? 'hover:shadow-md hover:border-primary/40 hover:-translate-y-1' : ''}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      <div className="relative flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{title}</p>
          <p className="mt-2 text-3xl font-bold text-foreground font-mono tabular-nums">{display}{suffix}</p>
          {subtitle && <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>}
        </div>
        <div className={`flex-shrink-0 h-11 w-11 rounded-full flex items-center justify-center ${iconClass}`}>
          <Icon className="h-5 w-5" strokeWidth={1.5} />
        </div>
      </div>
    </Wrapper>
  );
};
